import React, { useState } from "react"

const WorksitesContext = React.createContext({
  worksites: [],
  updateWorksites: () => {},
})

export const WorksitesContextProvider = (props) => {
  const [worksites, setWorksites] = useState([])

  const updateWorksitesHandler = (response_worksites) => {
    setWorksites([...response_worksites])
    localStorage.setItem("worksites", JSON.stringify(response_worksites))
  }

  const contextValue = {
    worksites: worksites,
    updateWorksites: updateWorksitesHandler,
  }

  return (
    <WorksitesContext.Provider value={contextValue}>{props.children}</WorksitesContext.Provider>
  )
}

export default WorksitesContext
